module.exports = __webpack_public_path__ + "media/images/review/sample-photo2-26fe2629e753cb6da3b9d8bb03c255b1.jpg";